import { createSlice } from "@reduxjs/toolkit";

const leaveSlice = createSlice({
  name: "leave",
  initialState: {
    managerPagination: { page: 1, pageSize: 15 },
    hrPagination: { page: 1, pageSize: 15 },
    wfhPagination: { page: 1, pageSize: 15 },

    managerSortModel: [],
    hrSortModel: [],
    wfhSortModel: [],
  },
  reducers: {
    setPagination: (state, action) => {
      const { tab, ...rest } = action.payload;
      if (tab === "manager") state.managerPagination = rest;
      else if (tab === "hr") state.hrPagination = rest;
      else state.wfhPagination = rest;
    },
    setSortModel: (state, action) => {
      const { tab, model } = action.payload;
      if (tab === "manager") state.managerSortModel = model;
      else if (tab === "hr") state.hrSortModel = model;
      else state.wfhSortModel = model;
    },
  },
});

export const { setPagination, setSortModel } = leaveSlice.actions;
export default leaveSlice.reducer;
